import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  createUserGroupSuccess,
  fetchAllUserGroupsBegin,
  fetchAllUserGroupsFailure,
  fetchAllUserGroupsSuccess,
  fetchUserGroupSuccess,
  setOneUserGroup,
  updateUserGroupSuccess,
  UserGroupAction,
} from './actions'
import { UserGroupsState } from './types'

export const userGroupsReducer = combineReducers<UserGroupsState, UserGroupAction>({
  isFetching: (isFetching = false, action) => {
    switch (action.type) {
      case getType(fetchAllUserGroupsBegin):
        return true
      case getType(fetchAllUserGroupsSuccess):
      case getType(fetchAllUserGroupsFailure):
        return false
      default:
        return isFetching
    }
  },
  items: (userGroups = {}, action) => {
    switch (action.type) {
      case getType(fetchAllUserGroupsSuccess):
        return action.payload.userGroups
      case getType(fetchUserGroupSuccess):
      case getType(createUserGroupSuccess):
      case getType(updateUserGroupSuccess):
      case getType(setOneUserGroup): {
        const { userGroup } = action.payload

        return {
          ...userGroups,
          [userGroup.id]: userGroup,
        }
      }
      default:
        return userGroups
    }
  },
})
